import React from "react";

interface GiftIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const GiftIcon: React.FC<GiftIconProps> = ({
  width = 18,
  height = 18,
  color = "#FFC640",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clipPath="url(#clip0_49_4205)">
      <path
        d="M6.69727 2.41875L7.9207 4.5H5.34375C4.5668 4.5 3.9375 3.8707 3.9375 3.09375C3.9375 2.3168 4.5668 1.6875 5.34375 1.6875H5.42109C5.94492 1.6875 6.43359 1.96523 6.69727 2.41875ZM2.25 3.09375C2.25 3.6 2.37305 4.07812 2.5875 4.5H1.125C0.502734 4.5 0 5.00273 0 5.625V7.875C0 8.49727 0.502734 9 1.125 9H16.875C17.4973 9 18 8.49727 18 7.875V5.625C18 5.00273 17.4973 4.5 16.875 4.5H15.4125C15.627 4.07812 15.75 3.6 15.75 3.09375C15.75 1.38516 14.3648 0 12.6562 0H12.5789C11.4574 0 10.4168 0.594141 9.84727 1.56094L9 3.00586L8.15273 1.56445C7.5832 0.594141 6.54258 0 5.42109 0H5.34375C3.63516 0 2.25 1.38516 2.25 3.09375ZM14.0625 3.09375C14.0625 3.8707 13.4332 4.5 12.6562 4.5H10.0793L11.3027 2.41875C11.5699 1.96523 12.0551 1.6875 12.5789 1.6875H12.6562C13.4332 1.6875 14.0625 2.3168 14.0625 3.09375ZM1.125 10.125V16.3125C1.125 17.2441 1.88086 18 2.8125 18H7.875V10.125H1.125ZM10.125 18H15.1875C16.1191 18 16.875 17.2441 16.875 16.3125V10.125H10.125V18Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_49_4205">
        <rect width="18" height="18" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GiftIcon;
